/** Rótulos em português para status e etapas do agente (valores internos permanecem em inglês). */

export const SESSION_STATUS_LABEL = {
  QUEUED: "Na fila de envio",
  ACTIVE: "Agente em conversa",
  AWAITING_USER: "Aguardando o autor",
  HUMAN_HANDOFF: "Atendimento humano",
  SCHEDULED: "Reunião marcada",
  ENDED: "Conversa encerrada",
  OPT_OUT: "Não quer contato",
};

export const SESSION_STATUS_COLOR = {
  QUEUED: "bg-gray-100 text-gray-600",
  ACTIVE: "bg-emerald-100 text-emerald-700",
  AWAITING_USER: "bg-blue-100 text-blue-700",
  HUMAN_HANDOFF: "bg-orange-100 text-orange-700",
  SCHEDULED: "bg-indigo-100 text-indigo-700",
  ENDED: "bg-gray-100 text-gray-500",
  OPT_OUT: "bg-red-100 text-red-700",
};

export const SESSION_STEP_LABEL = {
  GREETING: "Saudação",
  WAIT_GREETING_REPLY: "Aguardando resposta",
  PITCH_VALUE: "Apresentação",
  WAIT_PITCH_REPLY: "Aguardando interesse",
  HANDLE_OBJECTION: "Tratar objeção",
  OFFER_MEETING: "Oferta de reunião",
  WAIT_PERIOD: "Aguardando período",
  PRESENT_SLOTS: "Apresentar horários",
  WAIT_SLOT_CHOICE: "Aguardando horário",
  BOOK_SLOT: "Confirmar agendamento",
  WRAP_UP_SCHEDULED: "Encerramento agendado",
  NURTURE_LATER: "Nutrição",
  HANDOFF: "Transferência",
  OPT_OUT: "Descadastrar",
};

export function sessionStatusLabel(status) {
  return SESSION_STATUS_LABEL[status] || status || "—";
}

export function sessionStepLabel(step) {
  return SESSION_STEP_LABEL[step] || step || "—";
}
